import * as yup from 'yup';

export interface IQrEntry {
  id?: number;
  branded_image?: string;
  name: string;
  description: string;

  deactivated: boolean;
  url: string;
}

export interface ISingleQrOperations {
  onEdit?: (entry: IQrEntry) => void;
  onUpdate?: (entry: IQrEntry) => void;
  onRemove?: (id: number) => void;
}

export const initialValues: IQrEntry = {
  name: '',
  description: '',
  url: '',
  deactivated: false,
};

export const FormSchema = yup.object().shape({
  name: yup.string().required('QR name is required'),
  url: yup.string().required('Destination url is required'),
});

export const TextAreaStyles = {
  label: 'Description',
  required: false,
  size: 'small',

  multiline: true,
  rows: 3,
  className: 'bg-surface-2 rounded-xl',
  placeholder: 'Description',

  sx: {
    '& fieldset': { border: 'none' },
    '& .Mui-focused': {
      border: '1px solid var(--accent)',
      backgroundColor: 'var(--surface)',
    },
  },
  InputProps: {
    className: 'border border-transparent hover:border-text-2',
  },
  labelStyles: {
    color: 'var(--text)',
    fontWeight: 500,
    fontFamily: 'CircularStd',
  },
};

export const getLandingUrl = (id?: number): string => {
  let url = '';
  if (!id) return url;
  if(id < 400) {
    url = `https://thedesirecompany.com/qr/dynamic/${id}`;
  } else {
    url = `https://shoppers.thedesirecompany.com/qr/dynamic/${id}`;
  }
  return url;
}
